/** Shown when GET /api/ai/status reports configured: false. */
export const VANTI_NOT_CONFIGURED_MESSAGE =
  'Vanti is not configured. Add an AI provider key in Organisation Settings (Configuration → organisation settings → AI), or set GEMINI_API_KEY on the server and restart the API.';
